// Mock data for plumbing website

export const businessInfo = {
  name: "AA Plumbing and Roofing",
  logo: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/n3t4lakl_logo-removebg-preview.png",
  phone: "0499 923 699",
  phoneRaw: "+61499923699",
  email: "Contact@aaplumbingroofing.info",
  address: "Brunswick",
  city: "Melbourne",
  state: "VIC",
  zipCode: "3000"
};

export const heroSlides = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/s10lxmtu_Commerical%20Roof%20Replacement.JPG",
    title: "Commercial Roof Replacement",
    description: "Quality metal roofing for businesses across Melbourne"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/lumzgo29_Leak%20Detection.jpeg",
    title: "Leak Detection & Repairs",
    description: "Finding and fixing leaks before they become big problems"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/qnalun65_New%20Metal%20Build%20Roof.jpeg",
    title: "New Metal Roof Builds",
    description: "Brand new metal roofing for new home builds"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/j9ydvzgh_Roof%20Replacement.jpeg",
    title: "Residential Roof Replacement",
    description: "Transforming Melbourne homes with quality metal roofing"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/eopcplto_Sewer%20Repair.jpg",
    title: "Sewer & Storm Water Repairs",
    description: "Expert repair work for broken sewer and storm water pipes"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/s3hevuvi_Skylight%20Install.jpeg",
    title: "Skylight Installation",
    description: "Bringing beautiful natural light into your home"
  }
];

export const services = [
  {
    id: 1,
    title: "General Plumbing",
    description: "Complete plumbing services for brand new builds — from rough-in to fit-off, we handle every stage with precision and quality workmanship.",
    icon: "wrench",
    features: [
      "Rough-in & fit-off plumbing",
      "Fixture installations",
      "Gas installations",
      "Drainage & sanitary work",
      "New build plumbing",
      "Bathroom & kitchen fit-outs"
    ]
  },
  {
    id: 2,
    title: "Roof Plumbing",
    description: "Specialised metal roofing and roof plumbing services for both domestic and commercial properties — from new builds to leak repairs.",
    icon: "home",
    features: [
      "Metal roof replacement (domestic & commercial)",
      "Tile to tin conversions",
      "New metal roof builds",
      "Metal wall cladding",
      "Roof leak inspections & reports",
      "Leaky roof repairs",
      "Gutters, fascia, downpipes & rainheads",
      "Flashings, box gutters & cappings"
    ]
  },
  {
    id: 3,
    title: "Maintenance Plumbing",
    description: "Reliable maintenance and repair services for existing homes — keeping your plumbing running smoothly and preventing costly issues.",
    icon: "droplets",
    features: [
      "Hot water system repairs & replacements",
      "Sewer & storm water repairs",
      "Pipe camera inspections",
      "Blocked drains & toilets",
      "Leak detection & repairs",
      "Tap & mixer replacements"
    ]
  },
  {
    id: 4,
    title: "Skylight Installation",
    description: "Professional skylight installation, repair, and replacement services to bring beautiful natural light into any room of your home or office.",
    icon: "sun",
    features: [
      "New skylight installation",
      "Skylight repairs & replacement",
      "Sun tunnel installation",
      "Ventilating skylights",
      "Custom-sized skylights",
      "Leak repairs & flashing"
    ]
  }
];

export const googleReviews = {
  overallRating: 5.0,
  totalReviews: 12,
  profileUrl: "https://share.google/KZ1qpMS0DSu7KRhZr",
  reviews: [
    {
      id: 1,
      name: "Aaron Joseph",
      avatar: "A",
      rating: 5,
      date: "2 weeks ago",
      text: "Had some work done on our tin roof and couldn't be happier with the result. Communication was easy from start to finish, turned up when he said he would, and the quality of the work was solid. You can tell he knows roof plumbing and pays attention to the details instead of rushing through it. Left everything tidy afterwards too. Fair pricing and overall a really smooth experience. Would definitely recommend if you need roof plumbing or tin roof work done."
    },
    {
      id: 2,
      name: "Mahamed Elbaba",
      avatar: "M",
      rating: 5,
      date: "1 week ago",
      text: "I had an amazing experience with the team at AA Plumbing & Roofing. They replaced my old rusted roof and did an excellent job. The workmanship and service were outstanding."
    },
    {
      id: 3,
      name: "Colin Schmidt",
      avatar: "C",
      rating: 5,
      date: "5 months ago",
      text: "The team at AA Plumbing & Roofing are great hard working blokes. Very professional with a great attitude. I would hire them again in a heartbeat. I would definitely recommend them and their pricing is honest and fair."
    },
    {
      id: 4,
      name: "Jayden",
      avatar: "J",
      rating: 5,
      date: "6 months ago",
      text: "Really happy with the service from AA Plumbing & Roofing for my pergola. They turned up on time, easy to deal with, and did quality work. The price was also very reasonable compared to other quotes I got, and no surprises at the end. Great value for the service provided. Highly recommend!"
    },
    {
      id: 5,
      name: "Eveline Van Dyke",
      avatar: "E",
      rating: 5,
      date: "7 months ago",
      text: "The team at AA Plumbing & Roofing provided a professional service. Friendly, punctual, affordable, and very innovative and adaptable. I highly recommend them for whatever your plumbing needs are. By far the best plumbers I have used in a long time."
    },
    {
      id: 6,
      name: "Cara Callander",
      avatar: "C",
      rating: 5,
      date: "7 months ago",
      text: "Very impressed with the prompt professionalism and high-quality work of AA Plumbing and Roofing. They were efficient, reliable, and easy to communicate with throughout the entire process. I would certainly recommend their services to others."
    }
  ]
};

export const beforeAfterGallery = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/qk0ouzcm_New%20Metal%20Build%20Before.jpg",
    after: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/m6xza2qe_New%20Metal%20roof%20after.jpeg",
    title: "New Metal Roof Build",
    description: "Complete metal roof installation on a new build — from bare trusses to finished roof"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/zp6h3k98_Pergola%20Roof%20Before%20.jpg",
    after: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/iikrgh4a_Pergola%20roof%20after%20.jpeg",
    title: "Pergola Roof Installation",
    description: "Custom pergola roof with polycarbonate panels installed and weatherproofed"
  },
  {
    id: 3,
    before: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/ekbgnnai_Sewer%20Repair%20before.jpg",
    after: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/suj2rvr6_sewer%20pipe%20after.jpg",
    title: "Sewer Pipe Repair",
    description: "Broken sewer pipe excavated and replaced with new PVC pipework"
  }
];

export const recentWorkGallery = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/1h35orkp_IMG_3593.jpeg",
    title: "Roof Plumbing Project",
    description: "Quality metal roofing work completed for a Melbourne customer"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/cjf3jmqg_IMG_0835.jpeg",
    title: "Roofing Installation",
    description: "Professional roof plumbing — clean lines, tidy finish"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/s192a3qm_IMG_9958.jpeg",
    title: "Metal Roof Detail",
    description: "Precision flashings and quality workmanship"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/7j0g5czr_IMG_0817.jpeg",
    title: "On-Site Roofing Work",
    description: "Our team on the tools — delivering quality roof plumbing"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/an4oz4rr_IMG_9011.jpeg",
    title: "Completed Roof Project",
    description: "Another job done right — built to last for years to come"
  }
];

export const serviceAreas = [
  {
    region: "Inner Melbourne",
    suburbs: [
      "Melbourne CBD", "Carlton", "Fitzroy", "Collingwood", "Richmond",
      "South Yarra", "Prahran", "St Kilda", "South Melbourne", "Port Melbourne",
      "Docklands", "North Melbourne", "West Melbourne", "East Melbourne",
      "Abbotsford", "Cremorne", "Windsor", "Albert Park", "Middle Park"
    ]
  },
  {
    region: "Northern Suburbs",
    suburbs: [
      "Brunswick", "Brunswick East", "Brunswick West", "Coburg", "Coburg North",
      "Preston", "Reservoir", "Thornbury", "Northcote", "Fairfield", "Alphington",
      "Clifton Hill", "Pascoe Vale", "Pascoe Vale South", "Glenroy", "Hadfield",
      "Fawkner", "Broadmeadows", "Campbellfield", "Roxburgh Park", "Meadow Heights",
      "Craigieburn", "Mickleham", "Mernda", "Doreen", "Epping", "Mill Park",
      "South Morang", "Bundoora", "Greensborough", "Watsonia", "Macleod",
      "Heidelberg", "Heidelberg Heights", "Rosanna", "Ivanhoe", "Eaglemont",
      "Eltham", "Diamond Creek", "Research", "Montmorency"
    ]
  },
  {
    region: "Eastern Suburbs",
    suburbs: [
      "Hawthorn", "Hawthorn East", "Camberwell", "Kew", "Kew East", "Balwyn",
      "Balwyn North", "Canterbury", "Surrey Hills", "Mont Albert", "Box Hill",
      "Box Hill North", "Box Hill South", "Blackburn", "Blackburn North",
      "Blackburn South", "Mitcham", "Nunawading", "Forest Hill", "Vermont",
      "Vermont South", "Burwood", "Burwood East", "Mount Waverley", "Glen Waverley",
      "Wheelers Hill", "Doncaster", "Doncaster East", "Templestowe", "Templestowe Lower",
      "Bulleen", "Donvale", "Park Orchards", "Warrandyte", "Ringwood", "Ringwood East",
      "Ringwood North", "Croydon", "Croydon North", "Croydon South", "Heathmont",
      "Bayswater", "Boronia", "Wantirna", "Wantirna South", "Knoxfield",
      "Ferntree Gully", "Upper Ferntree Gully", "Rowville", "Lysterfield",
      "Lilydale", "Mooroolbark", "Chirnside Park", "Mont Albert North"
    ]
  },
  {
    region: "South Eastern Suburbs",
    suburbs: [
      "Caulfield", "Caulfield North", "Caulfield East", "Caulfield South",
      "Elsternwick", "Brighton", "Brighton East", "Hampton", "Hampton East",
      "Sandringham", "Black Rock", "Beaumaris", "Cheltenham", "Mentone",
      "Mordialloc", "Aspendale", "Aspendale Gardens", "Edithvale", "Chelsea",
      "Chelsea Heights", "Bonbeach", "Carrum", "Patterson Lakes", "Seaford",
      "Frankston", "Frankston North", "Frankston South", "Carrum Downs",
      "Skye", "Langwarrin", "Bentleigh", "Bentleigh East", "McKinnon", "Ormond",
      "Murrumbeena", "Hughesdale", "Carnegie", "Malvern", "Malvern East",
      "Glen Iris", "Ashburton", "Ashwood", "Chadstone", "Oakleigh", "Oakleigh East",
      "Oakleigh South", "Huntingdale", "Clayton", "Clayton South", "Notting Hill",
      "Mulgrave", "Springvale", "Springvale South", "Noble Park", "Noble Park North",
      "Keysborough", "Dingley Village", "Dandenong", "Dandenong North", "Dandenong South",
      "Doveton", "Hallam", "Endeavour Hills", "Narre Warren", "Narre Warren North",
      "Narre Warren South", "Berwick", "Beaconsfield", "Officer", "Pakenham",
      "Cranbourne", "Cranbourne East", "Cranbourne North", "Cranbourne West",
      "Clyde", "Clyde North", "Lyndhurst", "Lynbrook"
    ]
  },
  {
    region: "Western Suburbs",
    suburbs: [
      "Footscray", "West Footscray", "Yarraville", "Seddon", "Kingsville",
      "Maidstone", "Maribyrnong", "Braybrook", "Sunshine", "Sunshine North",
      "Sunshine West", "Albion", "Ardeer", "St Albans", "Deer Park", "Caroline Springs",
      "Burnside", "Burnside Heights", "Cairnlea", "Williamstown", "Williamstown North",
      "Newport", "Spotswood", "Altona", "Altona North", "Altona Meadows",
      "Laverton", "Point Cook", "Werribee", "Werribee South", "Hoppers Crossing",
      "Tarneit", "Truganina", "Wyndham Vale", "Manor Lakes", "Essendon",
      "Essendon North", "Essendon West", "Moonee Ponds", "Ascot Vale", "Flemington",
      "Kensington", "Travancore", "Aberfeldie", "Strathmore", "Strathmore Heights",
      "Avondale Heights", "Keilor", "Keilor East", "Keilor Park", "Niddrie", "Airport West"
    ]
  }
];

export const aboutPageExtras = {
  story: {
    title: "Our Story",
    paragraphs: [
      "AA Plumbing and Roofing was built on one simple principle: do the job properly, every single time. What started as a small operation in Brunswick has grown into one of Melbourne's most trusted plumbing and roofing teams — serving hundreds of homeowners, builders, and commercial clients across the city.",
      "Led by a fully licensed team with over 15 years of hands-on industry experience, we've worked on everything from heritage cottage repairs to large commercial metal roof installations. That deep experience is the foundation of everything we do — and it's why our clients keep coming back, and keep referring us to their friends and family.",
      "Today, we're proud to be 5-star rated on both Google and hipages, fully licensed and insured, and authorised partners with leading industry brands like Colorbond, BlueScope, and BPC."
    ]
  },
  values: [
    {
      title: "Honesty First",
      description: "Upfront pricing, transparent quotes, and clear communication. No surprises — ever."
    },
    {
      title: "Quality That Lasts",
      description: "We use premium materials and proven techniques so every job is built to last."
    },
    {
      title: "Respect for Your Property",
      description: "Tidy workmanship, drop sheets down, and a clean site at the end of every job."
    },
    {
      title: "Local & Reliable",
      description: "A local Melbourne team that turns up when we say we will — every single time."
    }
  ],
  expertise: {
    title: "Areas of Expertise",
    items: [
      "Brand new build plumbing — rough-in, fit-off, fixtures, drainage & gas",
      "Metal roof replacement & new metal builds (residential and commercial)",
      "Tile-to-tin roof conversions",
      "Skylight installation, repairs & sun tunnels",
      "Hot water system installation & repairs",
      "Sewer & storm water pipe repairs (with camera inspections)",
      "Gutter, downpipe, rainhead & box gutter installations",
      "Flashings, valleys, cappings & metal wall cladding"
    ]
  }
};

export const servicesPageExtras = {
  intro: {
    title: "Plumbing & Roofing Services Built for Melbourne Homes & Businesses",
    paragraphs: [
      "From a leaky tap to a full commercial metal roof replacement, AA Plumbing and Roofing delivers professional, fully-licensed services across every aspect of plumbing and roof plumbing. We handle new builds, renovations, repairs, and maintenance for residential and commercial clients across Melbourne.",
      "Every job is backed by upfront pricing, premium materials from trusted suppliers like Colorbond and BlueScope, and our 100% satisfaction guarantee."
    ]
  },
  whyChooseUs: [
    {
      stat: "15+",
      label: "Years of Trade Experience",
      description: "Hands-on expertise across residential, commercial, and industrial plumbing & roofing"
    },
    {
      stat: "5.0★",
      label: "Average Customer Rating",
      description: "Across Google and hipages — every job done to a standard our clients love"
    },
    {
      stat: "100%",
      label: "Licensed & Insured",
      description: "Fully accredited and compliant with BPC and WorkSafe Victoria standards"
    },
    {
      stat: "Free",
      label: "Quotes, Always",
      description: "No-obligation, upfront written quotes for every job — big or small"
    }
  ],
  faqs: [
    {
      q: "Do you do emergency or after-hours work?",
      a: "We do our absolute best to attend urgent jobs quickly — call us on 0499 923 699 and we'll let you know what we can do straight away."
    },
    {
      q: "Are you licensed and insured?",
      a: "Yes — we're fully licensed by BPC (Building and Plumbing Commission), compliant with WorkSafe Victoria, and carry full public liability and workers compensation insurance on every job."
    },
    {
      q: "Do you provide written quotes?",
      a: "Always. Every job — from a leaky tap to a full roof replacement — comes with a clear, no-obligation written quote so you know exactly what you're paying for before we start."
    },
    {
      q: "What areas of Melbourne do you cover?",
      a: "We service inner Melbourne, the northern suburbs, eastern suburbs, south-eastern suburbs, and western suburbs. See our contact page for the full list of suburbs we serve."
    },
    {
      q: "Do you offer warranties on your work?",
      a: "Yes. All our installations come with manufacturer warranties on materials, plus our own workmanship guarantee. We stand behind every job we do."
    },
    {
      q: "Do you do small repair jobs, or just big projects?",
      a: "Both! We treat a leaking tap with the same care as a full commercial roof — every customer matters, every job is worth doing properly."
    }
  ]
};

export const aboutUs = {
  eyebrow: "About Us",
  title: "Melbourne's Trusted Plumbing & Roofing Specialists",
  intro: "At AA Plumbing and Roofing, we've built our reputation on quality craftsmanship, honest pricing, and treating every property like it's our own. Whether you need a brand-new build plumbed from the ground up, a metal roof replaced, or a leaking tap fixed — we deliver the same high standard every time.",
  body: "Led by a licensed and insured team with over 15 years of hands-on industry experience, we specialise in residential and commercial plumbing, roof plumbing, and skylight installation across Melbourne. From the inner suburbs to the outer south east, east and north, we've earned the trust of homeowners, builders, and businesses through reliable service, transparent quotes, and workmanship that lasts.",
  closing: "When you choose AA Plumbing and Roofing, you're choosing a team that turns up on time, communicates clearly, and never cuts corners. We're proud to be 5-star rated on both Google and hipages — a reflection of the consistent quality and care we put into every job. We back our work with a 100% satisfaction guarantee, because your peace of mind matters as much as the work itself.",
  stats: [
    { value: "15+", label: "Years Experience" },
    { value: "500+", label: "Jobs Completed" },
    { value: "5.0★", label: "Google & hipages" },
    { value: "100%", label: "Satisfaction Guarantee" }
  ],
  highlights: [
    {
      title: "5-Star Rated on Google & hipages",
      description: "Our consistent 5-star reviews on both Google and hipages speak for the quality and care we deliver on every job."
    },
    {
      title: "Fully Licensed & Insured",
      description: "Qualified plumbers and roof plumbers, fully insured for your peace of mind on every job."
    },
    {
      title: "Quality Workmanship Guaranteed",
      description: "We stand behind our work with a satisfaction guarantee on every project — big or small."
    },
    {
      title: "Upfront, Honest Pricing",
      description: "No hidden fees, no surprise charges. You'll know the cost before we start the job."
    },
    {
      title: "Reliable & Punctual",
      description: "We show up when we say we will, and treat your home or business with the respect it deserves."
    },
    {
      title: "Residential & Commercial",
      description: "From single-room repairs to full commercial roof replacements — we handle jobs of every scale."
    }
  ]
};